import type { Measure } from './fit'

/** What a counter display's status pill adds around its words, in em (surfaces.css
 *  .counter-pill): padding 0.62 each side, the person glyph 0.95, the gap 0.4. */
export const PILL_OVERHEAD_EM = 0.62 * 2 + 0.95 + 0.4

const STEP = 0.92
const FLOOR = 10

/**
 * The font size at which a status pill fits its box's width: `start` when it does,
 * else smaller. "In service" outgrows the template's pill at full size, and the
 * longer az/ru words more so; the box clips, so a pill that does not shrink loses its end.
 */
export function pillSize(text: string, width: number, start: number, m: Pick<Measure, 'width'>): number {
  const fits = (size: number) => m.width(text, size) + PILL_OVERHEAD_EM * size <= width
  let size = start
  while (size > FLOOR && !fits(size)) size = Math.max(FLOOR, size * STEP)
  return size
}
